console.log(process.env.NODE_ENV)

const devConfig = {
    authority: 'https://auth.dev.mile.so',
    client_id: '257326495255560538@meraki',
    redirect_uri: 'http://localhost:8000/admin/domains',
    response_type: 'id_token token',
    scope: 'openid profile urn:zitadel:iam:user:metadata email',
    post_logout_redirect_uri: 'http://localhost:8000/login',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
};

const prodConfig = {
    authority: 'https://auth.mile.so',
    client_id: '257795092562117170@meraki',
    redirect_uri: 'https://yeti.mile.so/admin/domains',
    response_type: 'id_token token',
    scope: 'openid profile urn:zitadel:iam:user:metadata email',
    post_logout_redirect_uri: 'https://yeti.mile.so/login',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
};

const authConfig = {...(process.env.NODE_ENV === 'development' ? devConfig : prodConfig)}

export default authConfig;


// WEBPACK FOOTER //
// ./src/authConfig.js